/**
 * Web Style Import
 *
 */

import './dnb-value-block.scss'
